import { booleanAttribute, Component, inject, Input } from '@angular/core';
import { ExplainMainModuleEnum, ExplainModule } from '../../../core/user/user.model';
import { environment } from '../../../../environments/environment';
import { MainModuleManagerService } from 'src/app/shared/services/module-manager.service';

@Component({
  selector: 'ex-module-home',
  templateUrl: './ex-module-home.component.html',
  styleUrls: ['./ex-module-home.component.scss'],
})
export class ExModuleHomeComponent {
  mainModuleManagerService = inject(MainModuleManagerService);
  @Input({ transform: booleanAttribute }) linkToOtherModule? = false;
  phStyle = 'ph';

  alternativeSuggestedModule = this.mainModuleManagerService.alternativeExplainMainModule;
  currentModule = this.mainModuleManagerService.activeExplainMainModule;

  get isResponseOnlyUser(): boolean {
    return this.mainModuleManagerService.isResponseOnlyUser;
  }

  get userModules(): ExplainModule[] {
    return this.mainModuleManagerService.userModules;
  }

  navigateToOtherModule() {
    const url =
      this.mainModuleManagerService.alternativeExplainMainModule === ExplainMainModuleEnum.TENDERS
        ? `${environment.appBaseUrl}/tenders/watch`
        : `${environment.appBaseUrl}/search`;
    console.log('url', url);
    window.open(url, '_blank');
  }
}
